module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"error":"Please fill out the required fields","editTimer":"Edit timer","timerWarning":"Your timer is in the past"}}')
  delete Component.options._Ctor
}
